
.container {
  width: 100%;
}

.row {
  display: flex;
  min-height: 3rem;
  padding: 0.5rem 0;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
}

.selectPriceButton {
  margin-left: auto;
}

.priceRow {
  display: flex;
  min-height: 3rem;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
  margin: 0 calc(-1 * 1.5rem);
  padding: 0.5rem 1.5rem;
  border-radius: 1rem;
}

.priceRow:hover {
  background: var(--static-background-weak, #fafafa);
}

.priceBox {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex: 1;
}

.counter {
  padding: 0 6px;
  border-radius: 1000px;
  background: var(--sentiment-background-neutral, rgba(0, 0, 0, 0.08));
}
